import React from 'react';

import { GridOverlay } from '@mui/x-data-grid-premium';
import { makeStyles } from 'tss-react/mui';

import { EmptyState } from '../EmptyState';

const useStyles = makeStyles()(theme => ({
  emptyList: {
    paddingTop: 0,
  },
  emptyTitle: {
    marginRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

interface ListEmptyProps {
  title: string;
  icon?: JSX.Element | null;
  subtitle?: string;
}

export function ListEmpty({ icon = null, subtitle, title }: ListEmptyProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <GridOverlay>
      <EmptyState
        className={classes.emptyList}
        icon={icon}
        subtitle={subtitle}
        title={title}
        titleClass={classes.emptyTitle}
      />
    </GridOverlay>
  );
}
